import type { LinkedEntityBadge } from '@pesto/features/src/EntityProfile/types/LinkedEntityCard.types';

import { EntityEmptyState } from '@pesto/features/src/EntityProfile/components/EntityEmptyState';
import { LinkedEntityCard } from '@pesto/features/src/EntityProfile/components/LinkedEntityCard';
import { formatLoanStatus } from '@pesto/utils';
import { Landmark } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

import type { UserLoanListItem } from '../toUserDetail';

import { routes } from '../../../constants/routes';

interface UserLoansTabProps {
  loans: UserLoanListItem[];
}

const buildBadges = (loan: UserLoanListItem): LinkedEntityBadge[] => {
  const badges: LinkedEntityBadge[] = [];

  if (loan.status) badges.push({ label: formatLoanStatus(loan.status) });

  if (loan.isDelinquent) badges.push({ label: 'Delinquent' });

  return badges;
};

export const UserLoansTab = ({ loans }: UserLoansTabProps) => {
  const navigate = useNavigate();

  if (loans.length === 0) {
    return <EntityEmptyState icon={Landmark} title="This customer has no loans on file." />;
  }

  return (
    <div className="space-y-2">
      {loans.map((loan) => (
        <LinkedEntityCard
          key={loan.id}
          icon={Landmark}
          title={loan.programName ?? 'Loan'}
          subtitle={loan.partnerAccountNumber ?? loan.id}
          badges={buildBadges(loan)}
          onClick={() => navigate(routes.loans + '/' + loan.id)}
        />
      ))}
    </div>
  );
};
